var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_27893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3767 7.37921L13.9174 6.83853C14.8132 5.94271 16.2657 5.94271 17.1615 6.83853C18.0573 7.73436 18.0573 9.18679 17.1615 10.0826L16.6208 10.6233M13.3767 7.37921C13.3767 7.37921 13.4443 8.52816 14.4581 9.54193C15.4719 10.5557 16.6208 10.6233 16.6208 10.6233M13.3767 7.37921L8.406 12.3499C8.06932 12.6866 7.90098 12.855 7.75621 13.0406C7.58543 13.2595 7.43902 13.4964 7.31955 13.7471C7.21828 13.9596 7.143 14.1854 6.99243 14.6371L6.35441 16.5512M16.6208 10.6233L11.6501 15.594C11.3134 15.9307 11.1451 16.099 10.9594 16.2438C10.7405 16.4146 10.5036 16.561 10.2529 16.6805C10.0404 16.7817 9.81458 16.857 9.36287 17.0076L7.44881 17.6456M7.44881 17.6456L6.98093 17.8016C6.75864 17.8757 6.51357 17.8178 6.34789 17.6521C6.18221 17.4864 6.12435 17.2414 6.19845 17.0191L6.35441 16.5512M7.44881 17.6456L6.35441 16.5512",
    stroke: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_27893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditItemIcon);
export default __webpack_public_path__ + "static/media/edit-item-icon.01baeba807180be156ef728060aa6fb9.svg";
export { ForwardRef as ReactComponent };